module.exports = __webpack_public_path__ + "img/check-circle-fill.0b99c64a.svg";